import '../globalLibraries';
import '../coreLibraries';

// Strava
//
// This is the main entry point for react components. If you create a new
// component you will need to register in here.
//
// adding random string to force recompile:
// A998D3152224818D225A880A9B627F1FB4484DD7E408EACA1B243326ED4AA01B
import ReactComponentMounter from '../utils/react-component-mounter';

// Activity pages
import ActivityEditMapVisibilityApp from '../apps/activities/EditMapVisibilityApp';
import ActivityPublic from '../apps/activities/ActivityPublic';
import ActivityTagging from '../apps/activities/ActivityTagging';
import ActivityTruncate from '../apps/activities/Truncate';
import RelativeEffort from '../apps/activities/RelativeEffort';
import ExcludedEfforts from '../apps/activities/ExcludedEfforts';
import CorrectDistance from '../apps/activities/CorrectDistance/CorrectDistance';
import CorrectElevation from '../apps/activities/CorrectElevation/CorrectElevation';
import MapTypeInfo from '../apps/activities/MapTypeInfo/MapTypeInfo';
import HideStatsInfo from '../apps/activities/HideStatsInfo/HideStatsInfo';
// Athlete pages
import AthleteProfileApp from '../apps/AthleteProfileApp';
import LimitedProfileEntry from '../apps/AthleteProfileApp/components/LimitedProfileEntry';
// Settings pages
import EditPastActivitiesApp from '../apps/settings/EditPastActivitiesApp';
import PartnerIntegrationsApp from '../apps/settings/PartnerIntegrations';
import HideAddressApp from '../apps/settings/privacy/HideAddressApp';
import HideAnywhereApp from '../apps/settings/privacy/HideAnywhereApp';
// Subscription pages
import CheckoutApp from '../apps/subscriptions/Checkout';
import SummitPackageSelectUnpackedApp from '../apps/summit/PackageSelectUnpacked';
// Challenge pages
import Show from '../apps/challenges/Show';
// Dashboard pages
import MapVisModal from '../apps/dashboard/components/MapVisModal';
// Landing Page, Private Activities
import AccountSignupForm from '../components/shared/AccountSignupForm/AccountSignupForm';
// Account Registration
import RegistrationForm from '../apps/AccountRegistration/components/RegistrationForm';
// Other pages
import StarredSegment from '../components/StarredSegment';
import VisibilitySetting from '../components/VisibilitySetting';
import MapVisibilityControls from '../components/MapVisibilityControls';
import MentionableComment from '../components/MentionableComment';
import PerceivedExertionInput from '../components/PerceivedExertionInput';
import ProgressGoalsRelativeEffortTab from '../components/ProgressGoalsRelativeEffortTab';
import CreateSegmentApp from '../apps/publishes/CreateSegment';
import FeedbackApp from '../apps/FeedbackApp';

ReactComponentMounter.register({
  ActivityEditMapVisibilityApp,
  ActivityPublic,
  ActivityTagging,
  AthleteProfileApp,
  ActivityTruncate,
  RelativeEffort,
  ExcludedEfforts,
  CorrectDistance,
  CorrectElevation,
  MapTypeInfo,
  HideStatsInfo,
  EditPastActivitiesApp,
  PartnerIntegrationsApp,
  HideAddressApp,
  HideAnywhereApp,
  CheckoutApp,
  SummitPackageSelectUnpackedApp,
  StarredSegment,
  VisibilitySetting,
  MapVisibilityControls,
  MapVisModal,
  MentionableComment,
  PerceivedExertionInput,
  ProgressGoalsRelativeEffortTab,
  CreateSegmentApp,
  Show,
  FeedbackApp,
  LimitedProfileEntry,
  AccountSignupForm,
  RegistrationForm
});
